<div class="grid">
  <div class="grid__col-sm-10 grid__col-xs-12 center-item center-text">
    <h2 *ngIf="currentStepIndex === 0" class="h2" tabindex="-1" dgxAutofocus>
      {{ i18n.Onboarding_UploadResumeHeader }}
    </h2>
    <p *ngIf="currentStepIndex === 0" class="par guts-p-t-1">
      {{ onboarding_UploadResumeDescription }}
    </p>
    <h2 *ngIf="currentStepIndex === 1" class="h2" tabindex="-1" dgxAutofocus>
      {{
        'Onboarding_FoundExperienceHeader'
          | translate: { count: uploadedJobs?.length }
      }}
    </h2>
    <p *ngIf="currentStepIndex === 1" class="par guts-p-t-1">
      {{ i18n.Onboarding_ReviewExperienceDescription }}
    </p>
  </div>
  <div class="grid__col-xs-9 center-item guts-m-t-2">
    <ng-container>
      <aw-wizard
        class="onboarding-resume"
        [awNavigationMode]
        [navigateForward]="
          fileInfo && preprocessingCompleted ? 'allow' : 'deny'
        "
        navigateBackward="allow"
      >
        <aw-wizard-step (stepEnter)="preStepChange()">
          <ng-template awWizardStepTitle>
            <dgx-aw-wizard-step-label
              [currentIndex]="currentStepIndex"
              [stepIndex]="0"
              [stepTitle]="i18n.Onboarding_StepUpload"
              [stepIsValid]="true"
              size="large"
            ></dgx-aw-wizard-step-label>
          </ng-template>
          <ng-template awWizardStepSymbol>
            <df-icon
              class="color-ebony-a61"
              icon="chevron-right"
              size="medium"
            ></df-icon>
          </ng-template>
          <ng-container *ngTemplateOutlet="uploadSection"></ng-container>
        </aw-wizard-step>

        <aw-wizard-step (stepEnter)="preStepChange()">
          <ng-template awWizardStepTitle>
            <dgx-aw-wizard-step-label
              [currentIndex]="currentStepIndex"
              [stepIndex]="1"
              [stepTitle]="i18n.Onboarding_StepResults"
              [stepIsValid]="fileInfo && preprocessingCompleted"
              size="large"
            ></dgx-aw-wizard-step-label>
          </ng-template>
          <ng-container *ngTemplateOutlet="resultsSection"></ng-container>
        </aw-wizard-step>
      </aw-wizard>
    </ng-container>
  </div>
  <div class="grid__col-8 center-item guts-m-t-2">
    <ng-template #uploadSection>
      <div
        class="grid__col-md-6 grid__col-sm-8 grid__col-xs-12 center-item guts-m-t-2"
      >
        <dgx-upload-section
          [fileInfo]="fileInfo"
          [uploadAdapter]="fileUploaderAdapter"
          icon="arrow-up-tray"
          [errorMessages]="errorMessages"
          (uploadSuccessEvent)="preprocessingComplete($event)"
          (fileChangedEvent)="setFileInfo($event)"
          [labels]="labels"
        >
          <div class="icon-upload-spot bg-color-blue-light color-blue">
            <df-icon size="medium" icon="article"></df-icon>
          </div>
        </dgx-upload-section>
      </div>
    </ng-template>

    <ng-template #resultsSection>
      <div class="center-item guts-m-t-2 guts-m-h-1">
        <ng-container *ngIf="currentResume$ | async as resume">
          <h3 class="h3 guts-p-b-1">{{ i18n.Core_ExperiencesDisplayName }}</h3>

          <ng-container
            *ngFor="let experience of resume.userPositions"
            data-dgat="resume-parsing-95b"
          >
            <dgx-experience [experience]="experience"></dgx-experience>
          </ng-container>
          <!-- all skills from the entire resume -->
          <df-local-notification
            class="block guts-m-t-1-half"
            size="large"
            [text]="
              'Onboarding_ResumeAdditionalSkills'
                | translate: { count: resume.skills.length }
            "
            icon="info"
            [type]="NotificationType.info"
          ></df-local-notification>
        </ng-container>
      </div>
    </ng-template>
  </div>
</div>
